import { useDispatch } from "react-redux"
import LoanSlice from "./slice"
import { useCallback, useEffect } from "react"
import { toast } from "react-toastify"

export const { refresh,setLoan,setLoanId ,refreshFile,setOpenDetails } =
	LoanSlice.actions

export const useRefreshLoan = () => {
	const dispatch = useDispatch()
	const refreshFn = useCallback(() => {
		dispatch(refresh())
	}, [dispatch])
	return {refresh:refreshFn}
}
export const useRefreshFile = () => {
	const dispatch = useDispatch()
	const refreshFn = useCallback(() => {
		dispatch(refreshFile())
	}, [dispatch])
	return {refresh:refreshFn}
}

export const useSetLoan = (value) => {
	const dispatch = useDispatch()
	
	const setLoanFn = useCallback(
		(value) => {
			dispatch(setLoan(value))
			dispatch(setLoanId(value?.id))
		},
		[dispatch],
	)

	useEffect(() => {
		if (!value) return
		setLoanFn(value)
	}, [setLoanFn, value])
	
	return {setLoan:setLoanFn}
}
export const useSetLoanId = () => {
	const dispatch = useDispatch()
	const setLoanIdFn = useCallback(
		(value) => {
			dispatch(setLoanId(value))
		},
		[dispatch],
	)
	return {setLoanId:setLoanIdFn}
}
export const useSetOpenDetails = () => {
	const dispatch = useDispatch()
	const setOpenDetailsFn = useCallback(
		(value) => {
			toast.info(`Abriendo detalle de solicitud`, { autoClose: 2000 })
			dispatch(setOpenDetails(value))
		},
		[dispatch],
	)
	return {setOpenDetails:setOpenDetailsFn}
}
